import { useMemo, useState, useEffect, useCallback } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import _get from 'lodash/get';

const useEntityDialogState = () => {
  const history = useHistory();
  const location = useLocation();
  const params = useParams();

  const [id, setId] = useState<string | null>(null);
  const [open, setOpen] = useState(false);

  const onOpen = useCallback(
    (id: string) => {
      setId(id);
      history.push(`${location.pathname}/${id}`);
      setOpen(true);
    },
    [history, location]
  );

  const onClose = useCallback(() => {
    const newPathname = location.pathname.replace(/\/\b[a-f\d-]{36}\b/, '');
    history.push(newPathname);
    setOpen(false);
  }, [history, location]);

  const onClearId = useCallback(() => {
    setId(null);
  }, []);

  useEffect(() => {
    const id = _get(params, 'id');

    if (id && !open) {
      setId(id);
      setOpen(true);
    }

    if (!id && open) {
      setOpen(false);
    }
  }, [params]);

  return useMemo(
    () => ({
      id,
      open,
      onOpen,
      onClose,
      onClearId,
    }),
    [id, open, onOpen, onClose, onClearId]
  );
};

export default useEntityDialogState;
